import { LinkPresentationProps } from "@insite/mobius/Link";
import { colorPalette, colorStrings } from "@waytek/Utilities/variables";

export const link: { defaultProps?: LinkPresentationProps } = {
    defaultProps: {
        color: colorStrings.secondaryMain,
        typographyProps: {
            size: "inherit",
            lineHeight: "inherit",
        },
        hoverStyle: {
            color: colorPalette.secondary.main,
        },
    },
};
